// 行销来源（网址 ?referrer=）持久化：
// 进站时把 query 里的 referrer 写进 localStorage，注册时若当前网址上已经没有该参数
// （用户在站内换页、整页刷新、隔天回来再注册），仍能回退读取，避免来源标记丢失。
// 只保存来源字符串与写入时间，不涉及任何登录凭证。
import { getParameterByName } from './index'

export const REFERRER_STORAGE_KEY = 'signupReferrer'
// 30 天内有效，过期视为无来源
export const REFERRER_TTL_MS = 30 * 24 * 60 * 60 * 1000
// 后端字段长度有限，超长视为异常输入截断
const MAX_LENGTH = 200

function normalize (value) {
  return String(value || '').trim().slice(0, MAX_LENGTH)
}

// 读取网址上的 ?referrer=（hash 路由下 query 必须在 # 之前）
export function readUrlReferrer (url) {
  if (typeof window === 'undefined' && !url) return ''
  try {
    return normalize(getParameterByName('referrer', url))
  } catch (error) {
    // 参数不是合法的 URL 编码（decodeURIComponent 抛错）时视为没有来源
    return ''
  }
}

// 网址带 ?referrer= 时写入 localStorage 并返回该值；没有参数时不改动既有记录
export function rememberReferrer (url) {
  const referrer = readUrlReferrer(url)
  if (!referrer) return ''
  try {
    localStorage.setItem(REFERRER_STORAGE_KEY, JSON.stringify({ referrer, savedAt: Date.now() }))
  } catch (error) {
    // localStorage 不可用（隐私模式 / WebView 限制）时只影响持久化，不影响本次注册
  }
  return referrer
}

// 读取已持久化的来源；过期或格式不对时清掉并返回空字符串
export function getStoredReferrer (now = Date.now()) {
  try {
    const raw = localStorage.getItem(REFERRER_STORAGE_KEY)
    if (!raw) return ''
    const data = JSON.parse(raw)
    const referrer = normalize(data && data.referrer)
    const savedAt = Number(data && data.savedAt) || 0
    if (!referrer || now - savedAt > REFERRER_TTL_MS || now < savedAt - REFERRER_TTL_MS) {
      localStorage.removeItem(REFERRER_STORAGE_KEY)
      return ''
    }
    return referrer
  } catch (error) {
    return ''
  }
}

export function clearStoredReferrer () {
  try {
    localStorage.removeItem(REFERRER_STORAGE_KEY)
  } catch (error) {
    // 忽略存储异常
  }
}

// 注册时提交的 signupReferer：网址参数 > localStorage 持久化 > 浏览器 document.referrer
export function resolveSignupReferer (url) {
  const fromUrl = readUrlReferrer(url)
  if (fromUrl) return fromUrl
  const stored = getStoredReferrer()
  if (stored) return stored
  return typeof document !== 'undefined' ? (document.referrer || '') : ''
}
